import { keyframes, styled } from '@clickcease/cc-client-components-lib'

const border = '1px solid $lightNeutral'

export const AlertsBellWrapper = styled('div', {
  height: '24px',
  display: 'flex',
  paddingInline: '$4',
  borderRight: border,
})

export const AlertsBellTitleButton = styled('button', {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'end',
})

export const AlertsBellStyledText = styled('div', {
  fontSize: '$l',
  fontWeight: '$r',
  lineHeight: '19px',
  color: '$primaryColor',
})

const breathe = keyframes({
  '0%': { transform: 'scale(1)' },
  '50%': { transform: 'scale(1.1)' },
  '100%': { transform: 'scale(1)' },
})

export const AlertsBellIconWrapper = styled('div', {
  display: 'inline-block',
  color: '$primaryColor',
  animation: `${breathe.toString()} 0.5s ease-in-out infinite`,
})
